import {
  faBoxesStacked,
  faCalendarDays,
  faCube,
  faFileCheck,
  faFilePlus,
  faMoneyBillWave,
  faTicket,
  faTruckClock,
  faTruckFast,
} from '@fortawesome/pro-light-svg-icons';
import { SupportedIcon } from 'corso-admin-ui';
import { Pegasus } from 'corso-types';

export const returnOrWarrantyHookIcon = {
  [Pegasus.Hook.orderLookup]: 'search',

  [Pegasus.Hook.afterReasonSelection]: 'dashboard',

  [Pegasus.Hook.exchangeProductSelection]: 'exchange',

  [Pegasus.Hook.returnShipmentQuote]: 'shipment',

  [Pegasus.Hook.beforeClaimSubmission]: 'file',

  [Pegasus.Hook.claimCreated]: faFilePlus,

  [Pegasus.Hook.returnShipmentCreated]: 'box',

  [Pegasus.Hook.rmaWebhook]: 'warehouse',
  [Pegasus.Hook.returnShipmentWebhook]: faTruckClock,

  [Pegasus.Hook.beforeClaimLineItemInspection]: 'search',

  [Pegasus.Hook.claimFinalized]: faFileCheck,
  [Pegasus.Hook.claimLineItemReview]: 'order',
} as const satisfies Record<Pegasus.ReturnOrWarrantyHook, SupportedIcon>;

export const eventTypeIcon: Partial<Record<Pegasus.EventType, SupportedIcon>> =
  {
    [Pegasus.EventType.modifyResolutionWindow]: faCalendarDays,
    [Pegasus.EventType.askAPolicyEnforcingQuestion]: 'help',
    [Pegasus.EventType.collectCustomFields]: 'rule',
    [Pegasus.EventType.applyClaimTags]: 'tags',
    [Pegasus.EventType.applyOrderTags]: 'tags',
    [Pegasus.EventType.applyFee]: faMoneyBillWave,
    [Pegasus.EventType.applyLineItemFee]: faMoneyBillWave,
    [Pegasus.EventType.chargeForExchangeOrderShipping]: faMoneyBillWave,
    [Pegasus.EventType.chargeForReturnLabel]: faMoneyBillWave,
    [Pegasus.EventType.offerInstantExchange]: faTruckFast,
    [Pegasus.EventType.quoteOrderShipment]: 'globe',
    [Pegasus.EventType.quoteOrderShipmentParcel]: faCube,
    [Pegasus.EventType.quoteOrderShipmentModify]: 'filters',
    [Pegasus.EventType.omitResolutionMethods]: 'filters',
    [Pegasus.EventType.quoteOrderShipmentDeliveryEstimate]: 'pending',
    [Pegasus.EventType.orderEditing]: 'apiKey',
    [Pegasus.EventType.restockInventory]: 'warehouse',
    [Pegasus.EventType.shopNow]: 'order',
    [Pegasus.EventType.customizeReturnShipment]: faBoxesStacked,
    [Pegasus.EventType.createGorgiasTicket]: faTicket,
    [Pegasus.EventType.setOrderShippingTitle]: 'shipment',
    [Pegasus.EventType.shipClaimAllowedResolutions]: 'filters',
    [Pegasus.EventType.shipClaimReorderLocations]: 'warehouse',
    [Pegasus.EventType.shipClaimSlaAlert]: 'warningInline',
    [Pegasus.EventType.shipClaimReorderShipping]: 'shipment',
    [Pegasus.EventType.shipApplyOrderTags]: 'tags',
  };
